export default "__VITE_ASSET__DxVInI4c__"